// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rss.widget .main.content {
  display: flex;
  flex-direction: column;
}

.rss.widget .main.content > div {
  flex-direction: column;
}

.rss.widget .divided.list {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
}

.rss.widget .divided.list .item {
  flex-shrink: 0;
}

.rss.widget .divided.list .item .description {
  margin-left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/widgets/RSS/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".rss.widget .main.content {\n  display: flex;\n  flex-direction: column;\n}\n\n.rss.widget .main.content > div {\n  flex-direction: column;\n}\n\n.rss.widget .divided.list {\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n.rss.widget .divided.list .item {\n  flex-shrink: 0;\n}\n\n.rss.widget .divided.list .item .description {\n  margin-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
